module.exports = __webpack_public_path__ + "static/media/marketplace1.18950c61.png";